// extracted by mini-css-extract-plugin
export default {"panel":"R20Hm"};